import React from 'react'
import '../../styles/generalresultsloader.css';

export default function GeneralResultsLoader() {
  return (
    <div className='post-loader loading-roller'>
    </div>
  )
}
